import { labelPembayaran } from '../../utils/labelPembayaran';
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Paper,
  Divider,
  IconButton,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Chip,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  InputAdornment,
  Pagination,
  useTheme,

  BottomNavigation,
  BottomNavigationAction,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Avatar,
  ListItemButton,
  ListItemIcon,
  Container,
  Badge,
  Tooltip,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  AccessTime as AccessTimeIcon,
  Search as SearchIcon,
  Bluetooth as BluetoothIcon,
  Print as PrintIcon,
  Close as CloseIcon,
  ReceiptOutlined,
  Notifications as NotificationsIcon,
  PersonOutlined,
  LogoutOutlined,
  DescriptionOutlined,
  HomeOutlined,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import axios from 'axios';
import { format, formatDistanceToNow } from 'date-fns';
import Swal from "sweetalert2";
import { Logout, reset } from '../../fitur/AuthSlice';
import ThermalPrinter from './ThermalPrinter';
import LayoutKasir from './layoutKasir';
import { apiHost } from '../../utils/apiHost';
import { ambilKonfigStruk, barisStrukDariTransaksi } from '../../struk/strukWeb';
import { cetakBrowser } from '../../struk/cetakStruk';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === "https:" ? "https" : "http";
  const baseUrl = apiHost().replace(/^https?:\/\//, "");
  return `${protocol}://${baseUrl}`;
};

const fetcher = async (url) => {
    const response = await axios.get(url, {
      withCredentials: true
    });
    return response.data; 
  };

export const OrderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { id } = useParams(); 
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [sortOrder, setSortOrder] = useState('newest');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const apiBaseUrl = getApiBaseUrl();
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const [currentView, setCurrentView] = useState('detail');
  const [branchName, setBranchName] = useState("Nama Toko");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [printerInstance, setPrinterInstance] = useState(null);
  const [printerConnected, setPrinterConnected] = useState(false);
  const listApiUrl = `${apiBaseUrl}/getdetails?page=${currentPage}&limit=${itemsPerPage}`;
  const { data: listData, error: listError, mutate: mutateList } = useSWR(listApiUrl, fetcher);
  const detailApiUrl = selectedOrderId ? `${apiBaseUrl}/getdetails/${selectedOrderId}` : null;
  const { data: detailData, error: detailError, mutate: mutateDetail } = useSWR(
    detailApiUrl, 
    selectedOrderId ? fetcher : null
  );
  
  const { data: notificationData } = useSWR(
    `${apiBaseUrl}/notifications`,
    fetcher,
    { 
      refreshInterval: 30000, 
      revalidateOnFocus: true,
      dedupingInterval: 5000
    }
  );
  const notificationCount = notificationData?.data?.length || 0;
  
  const loading = !listData && !listError;
  const loadingDetail = selectedOrderId && !detailData && !detailError;
  
  useEffect(() => {
    const fetchBranchName = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
        setBranchName(response.data.cabang?.namacabang || "Nama Toko Tidak Diketahui");
      } catch (err) {
        console.error("Gagal mendapatkan nama cabang:", err);
        setBranchName("Nama Toko Tidak Diketahui");
      }
    };
    fetchBranchName();
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/produkpercabang') {
      setCurrentView('home');
    } else if (path === '/transaksikasir') {
      setCurrentView('history');
    } else if (path === '/notification' || path === '/notification-kasir') {
      setCurrentView('notification');
    } else if (path === '/detail' || path === '/detail-kasir') {
      setCurrentView('detail');
    } else if (path === '/profilekasir') {
      setCurrentView('profile');
    }
  }, [location.pathname]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterType, sortOrder]);
  
  useEffect(() => {
    if (id) {
      setSelectedOrderId(id);
      setModalOpen(true);
    }
    return () => {
        if (id) {
          setModalOpen(false);
        }
      };
  }, [id]);
  
  // Cetak nota pesanan: tata letak SAMA dengan struk kasir (struk/strukLayout.js, juga dipakai Flutter).
  const handlePrint = async (orderDetail) => {
    if (!orderDetail?.Transaksi) return;
    const { cabangConfig, logoUrl } = await ambilKonfigStruk(axios, getApiBaseUrl(), user?.cabang?.uuid);
    cetakBrowser(barisStrukDariTransaksi({ trx: orderDetail.Transaksi, cabangConfig, logoUrl }));
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedOrderId(null);
    if (id) {
      navigate('/orders', { replace: true });
    }
  };
  
  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleNotificationClick = () => {
    navigate('/notification-kasir');
  };

  const markAsRead = async (notificationId) => {
    try {
      await axios.post(`${apiBaseUrl}/notifications/read/${notificationId}`, {}, {
        withCredentials: true
      });
      mutateList();
      if (selectedOrderId) {
        mutateDetail();
      }
      
      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Notifikasi telah ditandai sebagai dibaca',
        timer: 1500
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: 'Gagal menandai notifikasi sebagai dibaca'
      });
    }
  };
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo(0, 0); 
  };
  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1); 
  };
  const viewOrderDetails = (notificationId) => {
    console.log('Viewing details for notification ID:', notificationId);
    setSelectedOrderId(notificationId);
    setModalOpen(true); 
  };
  const handleLogout = () => {
    try {
      dispatch(reset());
      dispatch(Logout());
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/');
    }
  };
  
  const processData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    let processedData = [...data];
    if (filterType !== 'all') {
      processedData = processedData.filter(item => item.type === filterType);
    }
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      processedData = processedData.filter(item => 
        item.message.toLowerCase().includes(searchLower) || 
        item.orderId.toLowerCase().includes(searchLower)
      );
    }
    
    // Sort based on time
    processedData.sort((a, b) => {
      const timestampA = new Date(a.timestamp).getTime();
      const timestampB = new Date(b.timestamp).getTime();
      return sortOrder === 'newest' ? timestampB - timestampA : timestampA - timestampB;
    });
    
    return processedData;
  };
  const notifications = listData && listData.success ? processData(listData.data) : [];
  const pagination = listData && listData.success ? listData.pagination : null;



  if (loading) {
    return (
      <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh', pb: isMobile ? 8 : 0 }}>
      
        <Container 
          maxWidth="lg" 
          sx={{ 
            mt: 3, 
            mb: 3,
            ml: 0,
            transition: 'margin 0.3s ease',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh'
          }}
        >
          <CircularProgress />
        </Container>
      </Box>
    );
  }
  if (listError) {
    return (
      <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh', pb: isMobile ? 8 : 0 }}>
    
        <Container 
          maxWidth="lg" 
          sx={{ 
            mt: 3, 
            mb: 3,
            ml: 0,
            transition: 'margin 0.3s ease',
            width: '100%'
          }}
        >
          <Alert severity="error" sx={{ borderRadius: '12px' }}>
            Gagal memuat data. {listError.message}
          </Alert>
        </Container>
      </Box>
    );
  }
  
  const renderOrderDetailModal = () => {
    if (loadingDetail) {
      return (
        <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
          <DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          </DialogContent>
        </Dialog>
      );
    }
    
    if (detailError) {
      return (
        <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
          <DialogContent>
            <Alert severity="error">
              Gagal memuat detail pesanan. {detailError.message}
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">Tutup</Button>
          </DialogActions>
        </Dialog>
      );
    }

    if (!detailData || !detailData.success || !detailData.data) return null;

    // Pastikan data diakses dengan aman
    const orderDetail = Array.isArray(detailData.data) ? detailData.data[0] : detailData.data;
    const transaksi = orderDetail?.Transaksi || {};

    console.log("Mapped Order Detail:", orderDetail);
    console.log("Mapped Transaction:", transaksi);

    return (
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Detail Pesanan</Typography>
            <Box>
              <IconButton onClick={() => handlePrint(orderDetail)} color="primary" sx={{ mr: 1 }}>
                <PrintIcon />
              </IconButton>
              <IconButton onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Card sx={{ mb: 3, borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#337ab7' }}>Informasi Pesanan</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Chip 
                  icon={orderDetail.read ? <CheckCircleIcon /> : <AccessTimeIcon />} 
                  label={orderDetail.read ? "Sudah Dibaca" : "Belum Dibaca"} 
                  color={orderDetail.read ? "success" : "warning"} 
                  size="small" 
                  sx={{ mr: 2 }}
                />
                <Typography variant="body2" color="text.secondary">
                  {format(new Date(orderDetail.timestamp), 'dd MMMM yyyy, HH:mm', { locale: id })}
                  {' '}({formatDistanceToNow(new Date(orderDetail.timestamp), { addSuffix: true, locale: id })})
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ mb: 1 }}>{orderDetail.message}</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle1" gutterBottom>ID Pesanan: {orderDetail.orderId}</Typography>
              <Typography variant="subtitle1" gutterBottom>Tipe: {orderDetail.type}</Typography>
              <Typography variant="subtitle1" gutterBottom>Status Pembayaran: {transaksi.status_pembayaran}</Typography>
              {transaksi.pembayaran && (
                <Typography variant="subtitle1" gutterBottom>Metode Pembayaran: {labelPembayaran(transaksi)}</Typography>
              )}
              <Typography variant="subtitle1" gutterBottom>Meja: {transaksi.tableId}</Typography>
            </CardContent>
          </Card>

          {/* Detail Barang */}
          <Card sx={{ mb: 3, borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#337ab7' }}>Detail Barang</Typography>
              <List disablePadding>
                {(transaksi.TransaksiDetails || []).map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ py: 1 }}>
                    <ListItemText
                      primary={item.Barang?.namabarang || "Barang Tidak Diketahui"}
                      secondary={`${item.jumlahbarang}x @ Rp ${Number(item.harga).toLocaleString('id-ID')}`}
                    />
                    <Typography variant="body1">
                      Rp {Number(item.total).toLocaleString('id-ID')}
                    </Typography>
                  </ListItem>
                ))}
                <Divider sx={{ my: 1 }} />
                <ListItem disablePadding sx={{ py: 1 }}>
                  <ListItemText primary="Total" />
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Rp {Number(transaksi.totaljual).toLocaleString('id-ID')}
                  </Typography>
                </ListItem>
              </List>
            </CardContent>
          </Card>

          {/* Informasi Cabang */}
          <Card sx={{ borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#337ab7' }}>Informasi Cabang</Typography>
              <Typography variant="subtitle1" gutterBottom>Nama Cabang: {transaksi.User?.Cabang?.namacabang || "N/A"}</Typography>
              <Typography variant="subtitle1" gutterBottom>Kasir: {transaksi.User?.username || "N/A"}</Typography>
            </CardContent>
          </Card>

          {/* Debug JSON Data */}
          {/* <Card sx={{ mt: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>Data JSON</Typography>
              <Box component="pre" sx={{ overflowX: 'auto', backgroundColor: '#f5f5f5', p: 2, borderRadius: 1, fontSize: '0.8rem' }}>
                {JSON.stringify({ success: true, data: orderDetail }, null, 2)}
              </Box>
            </CardContent>
          </Card> */}

        </DialogContent>
        <DialogActions>
          {!orderDetail.read && (
            <Button 
              variant="contained" 
              onClick={() => markAsRead(orderDetail.id)}
              sx={{
                bgcolor: '#337ab7',
                '&:hover': {
                  bgcolor: '#286090',
                },
                borderRadius: '8px'
              }}
            >
              Tandai Sebagai Dibaca
            </Button>
          )}
          <Button 
            onClick={handleCloseModal} 
            sx={{
              borderRadius: '8px'
            }}
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  return (
    <LayoutKasir
      currentView={currentView}
      onViewChange={setCurrentView}
      onNavigate={handleNavigate}
      onLogout={handleLogout}
      showPrinterSettings={showPrinterSettings}
      onShowPrinterSettings={setShowPrinterSettings}
      printerConnected={printerConnected}
      printerInstance={printerInstance}
      onSetPrinterInstance={setPrinterInstance}
    >
      <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh', pb: isMobile ? 8 : 0 }}>
      <ThermalPrinter 
        open={showPrinterSettings} 
        onClose={() => setShowPrinterSettings(false)}
        onPrinterConnected={(device) => {
          setPrinterInstance(device);
          setPrinterConnected(true);
        }}
        onPrinterDisconnected={() => {
          setPrinterInstance(null);
          setPrinterConnected(false);
        }}
        currentPrinter={printerInstance}
        connectionStatus={printerInstance?.getConnectionStatus?.()}
      />
     

      {isMobile && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
          <BottomNavigation
            value={currentView}
            onChange={(event, newValue) => {
              if (newValue === 'home') {
                handleNavigate('/produkpercabang');
                setCurrentView('home');
              } else if (newValue === 'history') {
                handleNavigate('/transaksikasir');
                setCurrentView('history');
                } else if (newValue === 'notification') {
                  handleNavigate('/notification-kasir');
                setCurrentView('notification');
              } else if (newValue === 'profile') {
                handleNavigate('/profilekasir');
                setCurrentView('profile');
              }
            }}
            showLabels
          >
            <BottomNavigationAction
              label="Home"
              value="home"
              icon={<HomeOutlined />}
            />
            <BottomNavigationAction
              label="Transaksi"
              value="history"
              icon={<ReceiptOutlined />}
            />
            <BottomNavigationAction
              label="Notifikasi"
              value="notification"
              icon={<NotificationsIcon />}
            />
            <BottomNavigationAction
              label="Profile"
              value="profile"
              icon={<PersonOutlined />}
            />
          </BottomNavigation>
        </Paper>
      )}

      <Container 
        maxWidth="lg" 
        sx={{ 
          mt: 3, 
          mb: 3,
          ml: 0,
          transition: 'margin 0.3s ease',
          width: '100%'
        }}
      >
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Cari pesan atau ID pesanan..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            margin="normal"
            sx={{
              backgroundColor: 'white',
              borderRadius: '12px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 2 }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: { xs: '100%', sm: 150 } }}>
              <InputLabel>Tipe</InputLabel>
              <Select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                label="Tipe"
              >
                <MenuItem value="all">Semua</MenuItem>
                <MenuItem value="order_accepted">Pesanan Diterima</MenuItem>
                <MenuItem value="order_completed">Pesanan Selesai</MenuItem>
                <MenuItem value="order_cancelled">Pesanan Dibatalkan</MenuItem>
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: { xs: '100%', sm: 150 } }}>
              <InputLabel>Urutan</InputLabel>
              <Select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                label="Urutan"
              >
                <MenuItem value="newest">Terbaru</MenuItem>
                <MenuItem value="oldest">Terlama</MenuItem>
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: { xs: '100%', sm: 150 } }}>
              <InputLabel>Item Per Halaman</InputLabel>
              <Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                label="Item Per Halaman"
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        {notifications.length === 0 ? (
          <Alert severity="info" sx={{ borderRadius: '12px' }}>
            Tidak ada pesanan yang ditemukan
          </Alert>
        ) : (
          <>
            <List component={Paper} sx={{ width: '100%', mb: 2, borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
              {notifications.map((notification, index) => (
                <React.Fragment key={notification.id}>
                  <ListItem 
                    alignItems="flex-start"
                    sx={{ 
                      cursor: 'pointer',
                      backgroundColor: notification.read ? 'inherit' : 'rgba(255, 107, 0, 0.05)',
                      '&:hover': {
                        backgroundColor: notification.read ? '#f5f5f5' : 'rgba(255, 107, 0, 0.1)',
                      }
                    }}
                    onClick={() => viewOrderDetails(notification.id)}
                  >
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="subtitle1" component="span">
                            {notification.orderId}
                          </Typography>
                          <Chip 
                            icon={notification.read ? <CheckCircleIcon /> : <AccessTimeIcon />} 
                            label={notification.read ? "Done" : "Pending"} 
                            color={notification.read ? "success" : "warning"} 
                            size="small" 
                          />
                        </Box>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'block' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {notification.message}
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              Total: Rp {Number(notification.Transaksi.totaljual).toLocaleString('id-ID')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {format(new Date(notification.timestamp), 'dd MMM yyyy, HH:mm', { locale: id })}
                            </Typography>
                          </Box>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  {index < notifications.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
            </List>
  
            {/* Pagination component */}
            {pagination && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 3 }}>
                <Pagination 
                  count={pagination.totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  sx={{
                    '& .MuiPaginationItem-root': {
                      '&.Mui-selected': {
                        backgroundColor: '#337ab7',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#286090',
                        }
                      }
                    }
                  }}
                  showFirstButton 
                  showLastButton
                />
              </Box>
            )}
  
            {/* Pagination summary */}
            {pagination && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  Menampilkan {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, pagination.totalItems)} dari {pagination.totalItems} data
                </Typography>
              </Box>
            )}
          </>
        )}
      
        {/* Render the modal for order details */}
        {renderOrderDetailModal()}
      </Container>
      </Box>
    </LayoutKasir>
  );
};

export default OrderDetails;